import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { checkOnboardingUser, onboardingNavbarSaga } from './onboardingNavbarSaga';

export function* onboardingNavIndexSaga() {
  yield takeLatest(sagaActions.GET_NAVBAR_COUNT, onboardingNavbarSaga);
  yield takeLatest(sagaActions.CHECK_ONBOARDING_USER, checkOnboardingUser);
}
